var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('site-header',{attrs:{"site":_vm.site}}),_c('main',{staticClass:"page-main"},[_c('router-view')],1),_c('site-footer',{attrs:{"site":_vm.site}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }